__turbopack_context__.v({
  "brands_content": "BrandsContent-module-scss-module__dyWQrW__brands_content",
  "brands_flex_container": "BrandsContent-module-scss-module__dyWQrW__brands_flex_container",
  "cta_block": "BrandsContent-module-scss-module__dyWQrW__cta_block",
});
